import { useQuery } from "@tanstack/react-query"

import staticSiteApi from "./staticSiteApi"

const useWhatsNewQuery = () => {
  const { data } = useQuery(["staticSiteApi.whatsNew"], staticSiteApi.whatsNew)

  return data
}

export default useWhatsNewQuery
